import React, { useEffect, useState } from "react";
import { getRecords } from "../../../services/api.service";
import { loaderOverlay } from "../../../Style/loaderOverly";
import { LoaderCreatePage } from "../../../pages/Loader/Loader";
import { toast } from "react-toastify";
import formatDateTime from "../../../custom/Utils/formatDateTime";

const UserDetailsModal = ({ onClose, id }) => {
    const [user, setUser] = useState(null);
    const [loadingData, setLoadingData] = useState(id ? true : false)
    const schema = localStorage.getItem("schema")
    const fetchData = async () => {
        setLoadingData(true)
        try {
            const payload = {
                modelName: "user_masters",
                schema: schema,
                whereCondition: {
                    id: id,
                },
                include: [
                    {
                        model: "role_masters",
                        as: "role",
                    },
                    {
                        model: "branch_masters",
                        as: "branch",
                    },
                    {
                        model: "zone_masters",
                        as: "zone",
                    },
                ],
            };
            const responseData = await getRecords(payload, "/getRecords");
            if (responseData.data && responseData.data.length > 0) {
                setUser(responseData.data[0]);
            }
        } catch (error) {
            console.error("Error: ", error)
            toast.error("Something went wrong! Please try again")
        }
        setLoadingData(false)
    };

    useEffect(() => {
        fetchData();
    }, [id]);


    return (
        <>
            <style>{`.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
 rgba(17, 25, 40, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  animation: modalFade 0.3s ease-out;
}

.modal-container {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column; /* IMPORTANT */
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  animation: modalSlide 0.4s ease-out;
}


.modal-header {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.modal-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.icon-button {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  color: #666;
  transition: all 0.2s;
}

.icon-button:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #1a1a1a;
}

.modal-content {
  padding: 20px;
  overflow-y: auto;
  max-height: calc(90vh - 80px); /* header height adjustment */
}


.user-avatar {
  text-align: center;
  margin-bottom: 32px;
}

.avatar-circle {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f9992d, #8b5cf6);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 600;
  margin: 0 auto 16px;
  text-transform: uppercase;
}

.user-avatar h3 {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.info-card {
  background: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.info-value {
  font-size: 16px;
  color: #1a1a1a;
  font-weight: 500;
}

.details-section {
  display: grid;
  gap: 24px;
  margin-bottom: 32px;
}

.detail-card {
  background: rgba(255, 255, 255, 0.8);
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.detail-card h4 {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 12px 0;
}

.detail-card p {
  font-size: 15px;
  color: #444;
  margin: 0;
  line-height: 1.5;
}

.stats-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 24px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.stat-item {
  text-align: center;
}

.stat-label {
  font-size: 14px;
  color: #666;
  display: block;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 16px;
  color: #1a1a1a;
  font-weight: 600;
}

.modal-content::-webkit-scrollbar {
  width: 6px;
}

.modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}


@keyframes modalFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes modalSlide {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 640px) {
  .modal-container {
    border-radius: 20px;
  }

  .modal-header {
    padding: 20px 24px;
  }

  .modal-content {
    padding: 24px;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .stats-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
 `}</style>

            <div
                className="modal-backdrop"
                style={{
                    background: "rgba(21, 2, 2, 0.5)", // Semi-transparent red background
                    backdropFilter: "blur(10px)", // Apply the blur effect
                    WebkitBackdropFilter: "blur(10px)", // For Safari support
                }}>
                <div className="modal-container" style={{ padding: "15px" }}>
                    <header className="modal-header">
                        <h2>Profile Details</h2>
                        <button className="icon-button" onClick={onClose}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M18 6L6 18M6 6l12 12"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </button>
                    </header>

                    <div className="modal-content">
                        <div className="user-avatar">
                            <div className="avatar-circle">
                                {user?.first_name?.[0]}
                                {user?.last_name?.[0]}
                            </div>
                            <h3>
                                {user?.first_name || "-"}{" "}
                                {user?.last_name || "-"}
                            </h3>
                        </div>

                        <div className="info-grid">
                            <div className="info-card">
                                <span className="info-label">Username</span>
                                <span className="info-value">
                                    {user?.username || "-"}
                                </span>
                            </div>
                            <div className="info-card">
                                <span className="info-label">Email</span>
                                <span className="info-value">
                                    {user?.email_id || "-"}
                                </span>
                            </div>

                            <div className="info-card">
                                <span className="info-label">Mobile Number</span>
                                <span className="info-value">
                                    {user?.mobile_number || "-"}
                                </span>
                            </div>
                            <div className="info-card">
                                <span className="info-label">Role</span>
                                <span className="info-value">
                                    {user?.role?.role_name || "-"}
                                </span>
                            </div>
                            
                            {user?.role_id === 2 && (<>
                                <div className="info-card">
                                    <span className="info-label">OEM</span>
                                    <span className="info-value">
                                        {user?.oems
                                            ?.map((item) => item.name)
                                            .join(", ") || "-"}
                                    </span>
                                </div>
                                <div className="info-card">
                                    <span className="info-label">Groups</span>
                                    <span className="info-value">
                                        {user?.groups
                                            ?.map((item) => item.name)
                                            .join(", ") || "-"}
                                    </span>
                                </div>
                            </>)}
                            <div className="info-card">
                                <span className="info-label">Created at</span>
                                <span className="info-value">
                                    {!user?.createdAt || loadingData
                                        ? "-"
                                        : formatDateTime(
                                            user.createdAt
                                        )}
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
                {loadingData && (<div style={loaderOverlay}>
                    <LoaderCreatePage />
                </div>)}

            </div>

        </>
    );
};

export default UserDetailsModal;
